module.exports = __webpack_public_path__ + "static/art4-5b22b7602d0eebf36a7dbefdaa04ffe5.png";